import React from 'react';
import PropTypes from 'prop-types';

import {
    createVideoEmbedCode,
    createChatEmbedCode,
} from 'common/compounds/VirtualEventBuilder/components/VirtualEventEmbedModal/videoEmbedHelpers';

import RawEmbed from './RawEmbed';

const createVideoUrl = (videoId) => `https://player.vimeo.com/video/${videoId}`;
const createChatUrl = (videoId) => `https://vimeo.com/live-chat/${videoId}`;

export default function VimeoEmbed({ videoId, supportsChat }) {
    const videoUrl = createVideoUrl(videoId);
    const chatUrl = supportsChat ? createChatUrl(videoId) : '';

    const videoEmbedCode = createVideoEmbedCode(videoUrl);
    const chatEmbedCode = chatUrl ? createChatEmbedCode(chatUrl) : '';

    const embedCode = [videoEmbedCode, chatEmbedCode].join('');

    return <RawEmbed embedCode={embedCode} />;
}

VimeoEmbed.propTypes = {
    videoId: PropTypes.string.isRequired,
    supportsChat: PropTypes.bool,
};

VimeoEmbed.defaultProps = {
    supportsChat: false,
};
